import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import Navbar from "./components/Navbar";
import SiteMeta from "./components/SiteMeta";
import Landing from "./pages/Landing";
import Restaurants from "./pages/Restaurants";
import RestaurantDetail from "./pages/RestaurantDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import DemoPage from "./pages/DemoPage";
import VoucherSuccess from "./pages/VoucherSuccess";
import MyBookings from "./pages/MyBookings";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import BookingDeposit from "./pages/BookingDeposit";
import EmbedBooking from "./pages/EmbedBooking";
import OrderOnline from "./pages/OrderOnline";
import OrderStatus from "./pages/OrderStatus";
import Survey from "./pages/Survey";
import EventTicket from "./pages/EventTicket";
import FindBooking from "./pages/FindBooking";
import GuestListPrint from "./pages/GuestListPrint";
import Tour from "./pages/Tour";

function Protected({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-background" data-testid="loading-screen" />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} position="bottom-right" />;
}

function App() {
  const isEmbed = window.location.pathname.startsWith("/embed");
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
        <AuthProvider>
          <SiteMeta />
          {!isEmbed && <div className="no-print"><Navbar /></div>}
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/restaurants" element={<Restaurants />} />
            <Route path="/c/:slug" element={<Restaurants />} />
            <Route path="/restaurants/:id" element={<RestaurantDetail />} />
            <Route path="/r/:id" element={<RestaurantDetail />} />
            <Route path="/embed/:rid" element={<EmbedBooking />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/voucher-success" element={<VoucherSuccess />} />
            <Route path="/my-bookings" element={<Protected roles={["diner", "admin"]}><MyBookings /></Protected>} />
            <Route path="/dashboard" element={<Protected roles={["owner", "manager", "host"]}><Dashboard /></Protected>} />
            <Route path="/print/guest-list/:rid/:date" element={<Protected roles={["owner", "manager", "host"]}><GuestListPrint /></Protected>} />
            <Route path="/tour" element={<Tour />} />
            <Route path="/admin" element={<Protected roles={["admin"]}><Admin /></Protected>} />
            <Route path="/payment/success" element={<Protected roles={["owner"]}><PaymentSuccess /></Protected>} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/find-booking" element={<FindBooking />} />
            <Route path="/booking-deposit" element={<BookingDeposit />} />
            <Route path="/order/:id" element={<OrderOnline />} />
            <Route path="/order-status" element={<OrderStatus />} />
            <Route path="/survey/:bookingId" element={<Survey />} />
            <Route path="/event-ticket" element={<EventTicket />} />
          </Routes>
          <ThemedToaster />
        </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
